import { createUseStyles } from 'react-jss';
import { __ } from '../functions/commom';

const useStyles = createUseStyles({
  footer: {
    fontSize: '14px',
    padding: '20px',
    textAlign: 'center',
    backgroundColor: '#ffffff',
    borderTop: '1px solid #ebebeb',
  },
});

function Footer() {
  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      {__('© 2025 Delta Asia Insurance Limited. All rights reserved.')}
    </footer>
  );
}

export default Footer;
